// src/config/auth.config.js

// Check if we're on localhost or a LAN IP
const IS_LOCALHOST = window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
  || window.location.hostname.includes('192.168.');

// For cross-subdomain cookies in production, we need a dot prefix.
// For localhost, dot prefix won't work, so we use plain 'localhost'.
const COOKIE_DOMAIN = IS_LOCALHOST ? 'localhost' : '.screamify.com';

export default {
  Auth: {
    // Cognito Region
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    
    // Cognito User Pool ID + Web Client ID
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_udsf6qiUL',
    userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '5q1ab1cj3br8gm1u9anpd3m6u1',

    // Use Amplify's built-in cookie storage
    storage: 'cookieStorage',
    cookieStorage: {
      domain: COOKIE_DOMAIN,
      path: '/',
      expires: 365,              // 365 days
      secure: !IS_LOCALHOST,     // Secure in production
      sameSite: IS_LOCALHOST ? 'lax' : 'none'
    },

    // Required for typical username/password flow
    // From Cognito console: using email, phone or username
    authenticationFlowType: 'USER_PASSWORD_AUTH',

    // OAuth configuration - domain must match exactly!
    oauth: {
      domain: 'us-east-1udsf6qiul.auth.us-east-1.amazoncognito.com',
      
      // Match exactly the scopes shown in Cognito console:
      // Email, OpenID, and Phone as configured
      scope: ['email', 'openid', 'phone'], 
      
      // Allowed callback URLs in Cognito → edit to add more if needed
      redirectSignIn: IS_LOCALHOST
        ? [
            'http://localhost:5173',
            'http://localhost:5174'
          ]
        : [
            'https://www.screamify.com',
            'https://shop.screamify.com',
            'https://community.screamify.com',
            'https://screamify.com',
            'https://streaming.screamify.com'
          ],
      
      // Allowed sign-out URLs in Cognito → edit to add more if needed
      redirectSignOut: IS_LOCALHOST
        ? [
            'http://localhost:5173',
            'http://localhost:5174'
          ]
        : [
            'https://www.screamify.com',
            'https://shop.screamify.com',
            'https://community.screamify.com',
            'https://screamify.com',
            'https://streaming.screamify.com'
          ],
      
      // Response type matches Authorization code grant selected in Cognito
      responseType: 'code'
    },
  }
};